import {
    Colors,
    Icon,
    PageContainer,
    Pills,
    Text,
    type OptionProps,
    type RadioGroupOption,
} from '@amelio/ui-library';

import { DefineAudienceContent } from './DefineAudienceContent/DefineAudienceContent';
import { DefineAudienceHeader } from './DefineAudienceHeader/DefineAudienceHeader';

import type { CycleAudienceTypeValue } from '@/constants/cycle-evaluation/CycleEvaluation';
import type {
    OnSelectCompanyAttributeOption,
    SelectedFilters,
} from '@/hooks/filters/useCompanyAttributesFilters';
import type { CompanyAttributeMap } from '@/utils/company';

import { DefineAudienceArrowIllustration } from '@/components/Illustrations/Illustration';
import { useAmelioTranslations } from '@/hooks';

interface DefineAudienceProps {
    isLoading: boolean;
    selectedEmployeesCount: number;
    options: RadioGroupOption[];
    selectedOption: CycleAudienceTypeValue;
    companyAttributes: OptionProps[];
    selectedCompanyAttributes: CompanyAttributeMap;
    filters: SelectedFilters;
    setSelectedOption: (option: CycleAudienceTypeValue) => void;
    onSelectCompanyAttribute: (value: string) => void;
    onSelectCompanyAttributeOption: ({ value, attribute }: OnSelectCompanyAttributeOption) => void;
}

export const DefineAudience = ({
    isLoading,
    selectedEmployeesCount = 0,
    options,
    selectedOption,
    companyAttributes,
    selectedCompanyAttributes,
    filters,
    setSelectedOption,
    onSelectCompanyAttribute,
    onSelectCompanyAttributeOption,
}: DefineAudienceProps) => {
    const { t } = useAmelioTranslations();

    return (
        <PageContainer>
            <DefineAudienceHeader />

            <DefineAudienceArrowIllustration
                className={'relative -top-9 left-40 -mb-20 sm:-top-20 sm:left-115 sm:-mb-28'}
            />

            <DefineAudienceContent
                isLoading={isLoading}
                options={options}
                selectedOption={selectedOption}
                companyAttributes={companyAttributes}
                selectedCompanyAttributes={selectedCompanyAttributes}
                filters={filters}
                setSelectedOption={setSelectedOption}
                onSelectCompanyAttribute={onSelectCompanyAttribute}
                onSelectCompanyAttributeOption={onSelectCompanyAttributeOption}
            />

            <Pills
                variant={'primary'}
                className={'mt-4'}
            >
                <div>
                    <Icon
                        name={'users-people'}
                        color={Colors.WHITE}
                    />
                </div>

                <Text color={Colors.WHITE}>
                    {t('cycleEvaluationDefineAudience.displaySelectedEmployees', {
                        count: selectedEmployeesCount,
                    })}
                </Text>
            </Pills>
        </PageContainer>
    );
};
